import { Box, styled } from "@mui/material";

export const Styled = {
    Box: styled(Box)`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
    Span: styled(Box)`
        font-weight: 700;
    `,
};
